<div class="field-group"
     [class.origami-updated]="isUpdatedByOrigami"
>
  <p-iftalabel class="w-full">
    @if (control(); as ctrl) {
      <input class="w-full p-inputtext"
             pInputText
             type="text"
             [formControl]="ctrl"
             [id]="inputId()"
             [invalid]="showInvalidState"
             [placeholder]="placeholder()"
      />
    }
    <label class="block font-medium mb-1"
           [for]="inputId()"
    >
      {{ label() }}
    </label>
  </p-iftalabel>
  @if (showRequiredHint) {
    <small class="block text-red-500 text-xs mt-1">{{ label() }} is required.</small>
  } @else if (showErrorMessage) {
    <small class="block text-red-500 text-xs mt-1">{{ errorMessage() }}</small>
  }
</div>
